import React, { useState, useRef, useEffect, useCallback } from 'react';
import {
    Button,
    // Chip,
    // Popover,
    Paper,
    // TextField,
    // InputAdornment,
    InputBase,
    CircularProgress,
    Typography,
    Grid,
    Divider,
    // Stack,
    styled,
    alpha,
    InputAdornment,
    IconButton
} from '@mui/material';
import {
	// SearchIcon,
	// Close,
	APIcon,
	GroupsIcon,
	UserIcon,
	// SsidIcon,
	SwitchIcon,
	SearchIconColored,
	SsidAddIcon,
	GreySearch,
} from '../../assets/icons';
import './AdvanceSearchBox.scss';
import useTheme from '../../hooks/useTheme';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { GROUP_ADD_TRIGGER, SHOW_GROUP_MODAL } from '../../constants/groupConstants';
import { SHOW_SWITCH_MODAL, SWITCH_ADD_TRIGGER } from '../../constants/switchConstants';
import { AP_ADD_TRIGGER, SHOW_AP_MODAL } from '../../constants/accessPointConstants';
import {
	SHOW_SSID_MODAL,
	SSID_ADD_TRIGGER,
} from '../../constants/ssid/ssidConstants';
import { USER_ADD_TRIGGER } from '../../constants/userConstants';
import { getSwitchList } from '../../actions/switches/switchApi';
import ApSearch from './ApSearch';
import { getGlobalApSearch } from '../../actions/accessPoint/accessPointList';
import { listGroup } from '../../actions/groupActions';
import SwitchSearch from './SwitchSearch';
import RecentSearchRow from './RecentSearchRow';
import GroupSearch from './groupSearch';
import {
	AP_GROUP_DASH_LOC,
	HOME_DASH_LOC,
} from '../../constants/commonConstants';
import { decryptData } from '../../utils/crypto';
import { encryptData } from '../../utils/crypto';
import { ClearOutlined } from '@mui/icons-material';
// import { listClients } from '../../actions/clientActions';
// import ClientDataSearch from './ClientDataSearch';
import { ADD_PERMISSION, AP_PERMISSION, AP_SSID_PERMISSION, GLOBAL_SSID_PERMISSION, MYUSER_PERMISSION, SITE_PERMISSION, SWITCH_PERMISSION } from '../../constants/permissionConstants';
import { fetchPermission } from '../../utils/utility';

const AdvanceSearchBox = () => {
	// eslint-disable-next-line react-hooks/rules-of-hooks
	const { color, FontFace, spacing } = useTheme();
	const isLocked = useSelector((state) => state.sidebarLock.isLocked);
	// eslint-disable-next-line no-unused-vars
	const [anchorEl, setAnchorEl] = useState(null);
	const dispatch = useDispatch();
	// eslint-disable-next-line no-unused-vars
	const [perPage, setPerPage] = useState(4);
	const [searchValue, setSearchValue] = useState('');
	const [isSearching, setIsSearching] = useState(false);
	const [searchObj, setSearchObj] = useState([]);
	const [groupSearch, setGroupSearch] = useState([]);
	const [switchSearch, setSwitchSearch] = useState([]);
	const [apCount, setApCount] = useState(0);
	const [groupCount, setGroupCount] = useState(0);
	const [switchCount, setSwitchCount] = useState(0);
	const [resetPagination, setResetPagination] = useState(false);
	const [pre, setPre] = useState(false);
	const location = useLocation();
	// eslint-disable-next-line no-unused-vars
	const [clientSearch, setClientSearch] = useState([]);
	// eslint-disable-next-line no-unused-vars
	const [bookmarkList, setBookmarkList] = useState([
		'Site Dashboard',
		'Access Point',
		'Switch',
		'Switch',
		'Switch',
		'Client12',
	]);
	const [recentSearches, setRecentSearches] = useState([]);

	const preDefinedSearches = [
		'Add Site',
		'Add SSID',
		'Add Switch',
		'Add Access Point',
		'Add User',
	];
	const isHome = location.pathname === '/dashboard';
	const isTopology = location.pathname === '/topology';
	const permissionMap = {
		'Add Site': fetchPermission(SITE_PERMISSION, ADD_PERMISSION),
		'Add AP': fetchPermission(AP_PERMISSION, ADD_PERMISSION),
		'Add Access Point': fetchPermission(AP_PERMISSION, ADD_PERMISSION),
		'Add Switch': fetchPermission(SWITCH_PERMISSION, ADD_PERMISSION),
		'Add SSID':
			(isHome &&
				fetchPermission(GLOBAL_SSID_PERMISSION) &&
				fetchPermission(GLOBAL_SSID_PERMISSION, ADD_PERMISSION)) ||
			(isTopology &&
				fetchPermission(AP_SSID_PERMISSION) &&
				fetchPermission(AP_SSID_PERMISSION, ADD_PERMISSION)) ||
			(!isHome && !isTopology &&
				fetchPermission(GLOBAL_SSID_PERMISSION) &&
				fetchPermission(GLOBAL_SSID_PERMISSION, ADD_PERMISSION)),
		'Add User': fetchPermission(MYUSER_PERMISSION, ADD_PERMISSION),
	};

	const [foundInRecent, setFoundInRecent] = useState(false);

	useEffect(() => {
		// Check if searchValue exists in recentSearches
		const found = recentSearches.some((item) =>
			item.toLowerCase().includes(searchValue.toLowerCase())
		);
		setFoundInRecent(found);
	}, [searchValue, recentSearches]);

	// eslint-disable-next-line no-unused-vars
	const [isEditingBookmark, setIsEditingBookmark] = useState(false);
	const quickSearch = [
		{ icon: GroupsIcon, text: 'Add Site' },
		{ icon: APIcon, text: 'Add AP' },
		{ icon: SwitchIcon, text: 'Add Switch' },
		{ icon: SsidAddIcon, text: 'Add SSID' },
		{ icon: UserIcon, text: 'Add User' },
	];

	const searchDivRef = useRef(null);
	const searchInputRef = useRef(null);
	const searchRequestId = useRef(0);
	const outsideClickRef = useRef(false);
	const [isFocused, setIsFocused] = useState(false);
	const [menuOpen, setMenuOpen] = useState(false);
	const [storedSelectedNode, setStoredSelectedNode] = useState('');
	const { selectedNode } = useSelector((state) => state.topology);
	const tourStep = useSelector((state) => state.tourGuideStep.tourStep);
	// eslint-disable-next-line no-unused-vars
	const [noResult, setNoResult] = useState(false);
	const [isSearched, setIsSearched] = useState(false);

	useEffect(() => {
		const storedNode = decryptData(localStorage.getItem('selectedNode'));
		setStoredSelectedNode(JSON.parse(storedNode));
	}, []);

	useEffect(() => {
		if (tourStep === 3) {
			setIsFocused(true);
			setMenuOpen(true);
		}
	}, [tourStep]);

	// useEffect(()=>{
	// 	const storedData = JSON.parse(localStorage.getItem('recentlySearched')) || {};

	// 	// Extract only the values (arrays) and flatten them into a single array
	// 	const allValues = Object.values(storedData).flat();

	// 	// Set the values in `recentSearches`
	// 	setRecentSearches(allValues);
	// 	console.log("??>>",recentSearches);
	// },[handleSearchInputChange])

	const handleFocusIn = () => {
		if (tourStep === 3){
			return;
		} // Prevent opening menu during tour step 3
		setMenuOpen(true);
		setIsFocused(true)
		// console.log('cheeck5',isFocused)

		// // Retrieve existing `recentlySearched` data from localStorage
		// const storedData = JSON.parse(localStorage.getItem('recentlySearched')) || {};

		// // Extract only the values (arrays) and flatten them into a single array
		// const allValues = Object.values(storedData).flat();

		// // Set the values in `recentSearches`
		// setRecentSearches(allValues);
	};

	console.log('recent', recentSearches);

	const handleClickOutside = useCallback((event) => {
		if (tourStep === 3) return;
		if (
			searchDivRef.current &&
			!searchDivRef.current.contains(event.target)
		) {
			outsideClickRef.current = true;
			searchRequestId.current += 1;
			setMenuOpen(false);
			setIsFocused(false);
			setSearchValue('');
			setIsSearching(false);
			setTimeout(() => {
				outsideClickRef.current = false;
			}, 0);
		}
	}, [tourStep]);

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [handleClickOutside]);

	const handleSearchInputChange = (e) => {
		searchRequestId.current += 1;
		setSearchValue(e.target.value);
		setSearchObj([]);
		setGroupSearch([]);
		setSwitchSearch([]);
		setApCount(0);
		setGroupCount(0);
		setSwitchCount(0);
		setNoResult(false);
		setIsSearched(false);
		setPre(false);
		setIsSearching(Boolean(e.target.value.trim()));
		setIsFocused(true);
		setMenuOpen(true);
	};

	useEffect(() => {
		if (
			isSearched &&
			(searchValue?.trim().length || 0) > 0 &&
			(searchObj?.length || 0) === 0 &&
			(groupSearch?.length || 0) === 0 &&
			(switchSearch?.length || 0) === 0 &&
			!foundInRecent &&
			!pre
		) {
			setNoResult(true);
		} else {
			setNoResult(false);
		}
	}, [
		searchValue,
		searchObj,
		groupSearch,
		switchSearch,
		isSearched,
		foundInRecent,
		pre,
	]);

	const searchAp = useCallback(async (search, requestId) => {
		const response = await dispatch(getGlobalApSearch(4, 0, null, search));
		if (requestId === searchRequestId.current) {
			setSearchObj(response?.results || []);
			setApCount(response?.count || 0);
		}
		return response;
	}, [dispatch]);

	// const searchClients = async (search) => {
	// 	const response = await dispatch(listClients(4, 0, search));
	// 	if (response?.results?.length > 0) {
	// 		setClientSearch(response.results);
	// 	} else {
	// 		setClientSearch([]);
	// 	}
	// };

	const searchGroup = useCallback(async (search, requestId) => {
		const updatedSearch = search.replace(/\s*\|\s*/g, ' and ');
		const result = await dispatch(listGroup(4, 0, updatedSearch));
		if (requestId === searchRequestId.current) {
			setGroupSearch(result?.results || []);
			setGroupCount(result?.count || 0);
		}
		return result;
	}, [dispatch]);

	const searchSwitch = useCallback(async (search, requestId) => {
		const response = await dispatch(getSwitchList(4, 0, null, search));
		if (requestId === searchRequestId.current) {
			setSwitchSearch(response?.results || []);
			setSwitchCount(response?.count || 0);
		}
		return response;
	}, [dispatch]);

	const handleBookmark = (value) => {
		if (!bookmarkList.includes(value)) {
			setBookmarkList([...bookmarkList, value]);
		}
	};

	// const handleRecentSearch = (value) => {
	// 	if (!recentSearches.includes(value)) {
	// 		setRecentSearches([...recentSearches, value]);
	// 	}
	// };

	const handleClearAll = () => {
		setBookmarkList([]);
		setRecentSearches([]);
		setMenuOpen(true);
		setIsFocused(true);
		console.log('cheeck1',isFocused)
		localStorage.removeItem('recentlySearched');
	};
	// const handleBookmarkEdit = () => {
	// 	setIsEditingBookmark(true);
	// 	setMenuOpen(true);
	// };
	// const handleBookmarkSave = () => {
	// 	setIsEditingBookmark(false);
	// 	setMenuOpen(true);
	// };

	const performSearch = useCallback(async (value, requestId) => {
		const trimmed = (value || '').trim();
		if (!trimmed) {
			setIsSearched(true);
			return;
		}
		setIsSearched(false);
		setIsSearching(true);
		setResetPagination(true);
		setTimeout(() => setResetPagination(false), 100);

		try {
			await Promise.all([
				searchAp(trimmed, requestId),
				searchSwitch(trimmed, requestId),
				searchGroup(trimmed, requestId),
			]);
		} finally {
			if (requestId === searchRequestId.current) {
				setIsSearching(false);
				setIsSearched(true);
				setMenuOpen(true);
				setIsFocused(true);
			}
		}
	}, [searchAp, searchGroup, searchSwitch]);

	useEffect(() => {
		const trimmed = searchValue.trim();
		if (!trimmed) {
			return undefined;
		}

		const requestId = searchRequestId.current;
		const timeout = setTimeout(() => {
			performSearch(trimmed, requestId);
		}, 350);

		return () => clearTimeout(timeout);
	}, [searchValue, performSearch]);

	const handleFocus = () => {
		if (tourStep === 3) {
			return;
		}
		setIsFocused(true);
		setMenuOpen(true);

		dispatch({ type: GROUP_ADD_TRIGGER, payload: false });
		dispatch({ type: AP_ADD_TRIGGER, payload: false });
		dispatch({ type: SWITCH_ADD_TRIGGER, payload: false });
		dispatch({ type: SSID_ADD_TRIGGER, payload: false });
		dispatch({ type: USER_ADD_TRIGGER, payload: false });
	};

	const handleClose = () => {
		setIsFocused(false);
		setMenuOpen(false)
	};

	const handleBlur = () => {
		if (tourStep === 3) {
			return;
		}
		if (outsideClickRef.current) {
			return;
		}
		if (searchValue) {
			// setTimeout(() => {
				setIsFocused(true);
			// }, 200);
		  } else if(!searchValue && menuOpen) {
			setIsFocused(true);
		  } else{
			setIsFocused(false);
			setMenuOpen(false)
		  }
	  };

	const { t } = useTranslation('dashboardState');
	const navigate = useNavigate();
	const handleGroupClick = () => {
		// If current path is '/dashboard', just open the modal
		if (location.pathname === '/dashboard') {
			dispatch({
				type: SHOW_GROUP_MODAL,
				payload: { displayGroupModal: true, modalLoc: HOME_DASH_LOC },
			});
			dispatch({ type: 'SET_ADD_GROUP_SOURCE', payload: 'sidebar' });
		} else {
			if (
				selectedNode === undefined ||
				(selectedNode &&
					Object.keys(selectedNode).length === 0 &&
					!storedSelectedNode)
			) {
				navigate('./dashboard');
				dispatch({
					type: SHOW_GROUP_MODAL,
					payload: { displayGroupModal: true, modalLoc: HOME_DASH_LOC },
				});
				dispatch({ type: 'SET_ADD_GROUP_SOURCE', payload: 'sidebar' });
			}
			else {
			// Navigate to topology and then open the modal
			navigate('./topology');
			if (
				selectedNode === undefined ||
				(selectedNode &&
					Object.keys(selectedNode).length === 0 &&
					!storedSelectedNode)
			) {
				dispatch({
					type: SHOW_GROUP_MODAL,
					payload: { displayGroupModal: true, modalLoc: HOME_DASH_LOC },
				});
				dispatch({ type: 'SET_ADD_GROUP_SOURCE', payload: 'sidebar' });
			} else {
				dispatch({
					type: SHOW_GROUP_MODAL,
					payload: { displayGroupModal: true, modalLoc: AP_GROUP_DASH_LOC },
				});
			}
		}
		}
		handleClose();
	};
	const handleApClick = () => {
		// If current path is '/dashboard', just open the modal
		if (location.pathname === '/dashboard') {
			dispatch({
				type: SHOW_AP_MODAL,
				payload: { displayApModal: true, modalLoc: HOME_DASH_LOC },
			});
		} else {
			if (
				selectedNode === undefined ||
				(selectedNode &&
					Object.keys(selectedNode).length === 0 &&
					!storedSelectedNode)
			) {
				navigate('./dashboard');
				dispatch({
					type: SHOW_AP_MODAL,
					payload: { displayApModal: true, modalLoc: HOME_DASH_LOC },
				});
			}
			else {
			// Navigate to topology and then open the modal
			navigate('./topology');
			if (
				selectedNode === undefined ||
				(selectedNode &&
					Object.keys(selectedNode).length === 0 &&
					!storedSelectedNode)
			) {
				dispatch({
					type: SHOW_AP_MODAL,
					payload: { displayApModal: true, modalLoc: HOME_DASH_LOC },
				});
			} else {
				dispatch({
					type: SHOW_AP_MODAL,
					payload: { displayApModal: true, modalLoc: AP_GROUP_DASH_LOC },
				});
			}
		}
		}
		handleClose();
	};

	const handleSwitchClick = () => {
		// If current path is '/dashboard', just open the modal
		if (location.pathname === '/dashboard') {
			dispatch({
				type: SHOW_SWITCH_MODAL,
				payload: { displaySwitchModal: true, modalLoc: HOME_DASH_LOC },
			});
		} else {
			if (
				selectedNode === undefined ||
				(selectedNode &&
					Object.keys(selectedNode).length === 0 &&
					!storedSelectedNode)
			) {
				navigate('./dashboard');
				dispatch({
					type: SHOW_SWITCH_MODAL,
					payload: { displaySwitchModal: true, modalLoc: HOME_DASH_LOC },
				});
			}
			else {
			// Navigate to topology and then open the modal
			navigate('./topology');
			if (
				selectedNode === undefined ||
				(selectedNode &&
					Object.keys(selectedNode).length === 0 &&
					!storedSelectedNode)
			) {
				dispatch({
					type: SHOW_SWITCH_MODAL,
					payload: { displaySwitchModal: true, modalLoc: HOME_DASH_LOC },
				});
			} else {
				dispatch({
					type: SHOW_SWITCH_MODAL,
					payload: { displaySwitchModal: true, modalLoc: AP_GROUP_DASH_LOC },
				});
			}
		}
		}
		handleClose();
	};
	const handleSSIDClick = () => {
		// If current path is '/dashboard', just open the modal
		if (location.pathname === '/dashboard') {
			dispatch({
				type: SHOW_SSID_MODAL,
				payload: { displaySSIDModal: true, modalLoc: HOME_DASH_LOC },
			});
		} else {
			if (
				selectedNode === undefined ||
				(selectedNode &&
					Object.keys(selectedNode).length === 0 &&
					!storedSelectedNode)
			) {
				navigate('./dashboard');
				dispatch({
					type: SHOW_SSID_MODAL,
					payload: { displaySSIDModal: true, modalLoc: HOME_DASH_LOC },
				});
			}
			else {
			// Navigate to topology and then open the modal
			navigate('./topology');
			if (
				selectedNode === undefined ||
				(selectedNode &&
					Object.keys(selectedNode).length === 0 &&
					!storedSelectedNode)
			) {
				dispatch({
					type: SHOW_SSID_MODAL,
					payload: {
						displaySSIDModal: true,
						modalLoc: HOME_DASH_LOC,
					},
				});
			} else {
				dispatch({
					type: SHOW_SSID_MODAL,
					payload: {
						displaySSIDModal: true,
						modalLoc: AP_GROUP_DASH_LOC,
					},
				});
			}
		}
		}
		handleClose();
	};
	const handleUserClick = () => {
		navigate('./system?tab=user_management');
		dispatch({ type: USER_ADD_TRIGGER, payload: true });
		handleClose();
	};

	// const handleDeleteBookmarkList = (itemToDelete) => {
	// 	setBookmarkList((prevList) => prevList.filter((item) => item !== itemToDelete));
	// };

const handleRecentSearchClick = (item) => {
	setMenuOpen(true);
	setIsFocused(true);
	searchRequestId.current += 1;
	setSearchObj([]);
	setGroupSearch([]);
	setSwitchSearch([]);
	setIsSearched(false);
	setNoResult(false);
	setPre(false);
	setIsSearching(true);
	setSearchValue(item);
};

const filteredQuickSearch = quickSearch.filter(
	item => permissionMap[item.text]
);

return (
		<>
			{/* <Tooltip
				content="⌘ + F"
				type="basic"
				direction="down"
				delay={300}
				style={{ width: 'auto' }}
			> */}
			<div
				className={`${tourStep === 3 ? 'highlighted-searchbox' : ''}`}
				style={{
					pointerEvents: isLocked || tourStep === 3 ? 'none' : 'auto',
					zIndex: isLocked || tourStep === 3 ? 9999 : 'auto',
				}}
			>
				<Search
					ref={searchDivRef}
					fontStyle={useTheme()}
					focused={
						tourStep === 3
							? true
							: isFocused || Boolean(anchorEl) || menuOpen
					}
					tourStep={tourStep}
					onClick={(event) => {
						const target = event.target;
						const clickedAction =
							target instanceof Element &&
							target.closest(
								'button, .recentSearchRow, .quickaccess-row',
							);
						if (!clickedAction && tourStep !== 3) {
							setIsFocused(true);
							setMenuOpen(true);
							searchInputRef.current?.focus();
						}
					}}
					style={{ '--highlight-color': color.text.hyperlink }}
					// className={tourStep === 3 ? 'search-input-container' : ''}
					// sx={{
					// 	...(tourStep === 3 && {
					// 	  '&:before, &:after': {
					// 		display: 'none'
					// 	  }
					// 	})
					//   }}
				>
					<SearchIconWrapper>
						{isFocused && (
							<SearchIconColored width={'16px'} height={'16px'} />
						)}
						{!isFocused && <GreySearch />}
					</SearchIconWrapper>
					<StyledInputBase
						id="inputBase"
						inputRef={searchInputRef}
						fontStyle={useTheme()}
						placeholder={t('Search in io Canvas')}
						value={searchValue}
						tourStep={tourStep}
						onChange={handleSearchInputChange}
						onFocus={handleFocus}
						onBlur={handleBlur}
						focused={
							tourStep === 3
								? true
								: isFocused || Boolean(anchorEl) || menuOpen
						}
						disabled={tourStep === 3}
						endAdornment={
							isSearching ? (
								<InputAdornment position="end" sx={{ width: 'auto' }}>
									<CircularProgress
										size={16}
										sx={{ marginRight: '8px' }}
									/>
								</InputAdornment>
							) : searchValue ? (
								<InputAdornment position="end" sx={{ width: 'auto' }}>
									<IconButton
										onClick={(event) => {
											event.stopPropagation();
											searchRequestId.current += 1;
											setSearchValue('');
											setSearchObj([]);
											setGroupSearch([]);
											setSwitchSearch([]);
											setApCount(0);
											setGroupCount(0);
											setSwitchCount(0);
											setIsSearching(false);
											setNoResult(false);
											setIsSearched(false);
											setPre(false);
											setIsFocused(true);
											setMenuOpen(true);
											searchInputRef.current?.focus();
										}}
									>
										<ClearOutlined
											sx={{ width: '16px', height: '16px' }}
										/>
									</IconButton>
								</InputAdornment>
							) : (
								<InputAdornment position="end" sx={{ width: '32px' }} />
							)
						}
					/>
					{(isFocused || menuOpen|| tourStep === 3) && (
						<Paper
							sx={{
								position: 'absolute',
								top: '100%',
								left: -2,
								right: -2,
								mt: 0,
								maxHeight: '90vh',
								overflowY: 'hidden',
								overflowX: 'hidden',

								boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)', // Add shadow
								border: tourStep === 3 ? '2px solid #500d76' : '1px solid #E0E0E0', // Add border
								borderRadius: tourStep === 3 ? '0px' : '8px', // Add border-radius for rounded corners
							}}
							PaperProps={{
								sx: {
									pointerEvents:
										tourStep === 3 ? 'none' : 'auto',
								},
							}}
							slotProps={{
								root: {
									style: {
										pointerEvents:
											tourStep === 3 ? 'none' : 'auto',
									},
								},
							}}
						>
							<Grid container>
								<Grid item xs={12}></Grid>
								<Grid
									style={{
										width: '100%',
										paddingTop: '10px',
									}}
								>
									{searchValue &&
										preDefinedSearches
											.filter(item => permissionMap[item])
											.filter((item) =>
												item
													.toLowerCase()
													.includes(
														searchValue.toLowerCase(),
													),
											)
											.map((item, index) => (
												<RecentSearchRow
													type="recentsearch"
													key={index}
													index={index}
													item={item}
													handleBookmark={
														handleBookmark
													}
													color={color}
													FontFace={FontFace}
													setPre={setPre}
													onClick={(item) => {
														const storedData =
															JSON.parse(
																localStorage.getItem(
																	'recentlySearched',
																),
															) || {};

														if (
															!storedData[
																'predefined'
															]
														) {
															storedData[
																'predefined'
															] = [];
														}

														const decryptedPredefined =
															storedData[
																'predefined'
															].map((encrypted) =>
																decryptData(
																	encrypted,
																),
															);

														if (
															!decryptedPredefined.includes(
																item,
															)
														) {
															const encryptedItem =
																encryptData(
																	item,
																);
															storedData[
																'predefined'
															].push(
																encryptedItem,
															);
														}

														localStorage.setItem(
															'recentlySearched',
															JSON.stringify(
																storedData,
															),
														);

														setMenuOpen(false);
														setIsFocused(false);
														setSearchValue('');

														switch (item) {
															case 'Add Site':
																handleGroupClick();
																handleClose();
																break;
															case 'Add SSID':
																handleSSIDClick();
																break;
															case 'Add Switch':
																handleSwitchClick();
																break;
															case 'Add Access Point':
																handleApClick();
																break;
															case 'Add User':
																handleUserClick();
																break;
															default:
																break;
														}
													}}
												/>
											))}
									<ApSearch
										searchObj={searchObj}
										handleFocusIn={handleFocusIn}
										setSearchObj={setSearchObj}
										setSearchValue={setSearchValue}
										setIsSearched={setIsSearched}
										searchValue={searchValue}
										setMenuOpen={setMenuOpen}
										setIsFocused={setIsFocused}
										apCount={apCount}
										resetPagination={resetPagination}
									/>
									<SwitchSearch
										switchSearch={switchSearch}
										handleFocusIn={handleFocusIn}
										setSwitchSearch={setSwitchSearch}
										setSearchValue={setSearchValue}
										searchValue={searchValue}
										setMenuOpen={setMenuOpen}
										setIsFocused={setIsFocused}
										switchCount={switchCount}
										resetPagination={resetPagination}
									/>
									<GroupSearch
										searchObj={groupSearch}
										handleFocusIn={handleFocusIn}
										setSearchObj={setGroupSearch}
										setSearchValue={setSearchValue}
										searchValue={searchValue}
										setMenuOpen={setMenuOpen}
										setIsFocused={setIsFocused}
										groupCount={groupCount}
										resetPagination={resetPagination}
									/>
									{/* <ClientDataSearch
										searchObj={clientSearch}
										handleFocusIn={handleFocusIn}
										setSearchObj={setClientSearch}
										searchValue={searchValue}
									/> */}
								</Grid>
								{noResult && (
									<Grid
										sx={{
											marginBottom: '20px',
											marginTop: '20px',
										}}
									>
										<Typography
											style={{
												textAlign: 'center',
												color: color.text.secondary,
												fontSize:
													FontFace.font_size.x_small,
												fontFamily: 'Inter-Bold',
												width: '425px',
												height: '16px',
											}}
										>
											No result found for your search.
										</Typography>
										<Typography
											style={{
												textAlign: 'center',
												color: color.text.secondary,
												fontSize:
													FontFace.font_size.x_small,
												fontFamily: 'Inter-Regular',
												width: '425px',
												height: '16px',
											}}
										>
											Try with a different keyword
										</Typography>
									</Grid>
								)}
								{!searchValue.trim() && (
									<div style={{ width: '100%' }}>
										{/* <Grid
										item
										xs={12}
										style={{
											padding: '12px',
											width: '437px',
										}}
									> */}
										{/* <Grid
											style={{
												paddingBottom: '12px',
												display: 'flex',
												flexDirection: 'row',
												justifyContent: 'space-between',
												alignItems: 'center',
											}}
										>
											<Typography
												style={{
													color: color.text.primary,
													fontSize:
														FontFace.font_size
															.xx_inputlabel,
													fontFamily: 'Inter-Bold',
												}}
											>
												Bookmark List
											</Typography>
											<Grid
												style={{
													display: 'flex',
													flexDirection: 'row',
													alignItems: 'center',
												}}
											>
												{!isEditingBookmark && (
													<Button
														style={{
															textTransform:
																'none',
															color: color.button
																.secondary_text,
															fontSize:
																FontFace
																	.font_size
																	.xx_inputlabel,
															fontFamily:
																'Inter-Regular',
															paddingLeft: '30px',
															backgroundColor:
																'transparent',
															'&:hover': {
																backgroundColor:
																	'transparent',
															},
														}}
														className="bookmarkEditButton"
														onClick={
															handleBookmarkEdit
														}
													>
														Edit
													</Button>
												)}
												{isEditingBookmark && (
													<Button
														style={{
															textTransform:
																'none',
															color: color.button
																.secondary_text,
															fontSize:
																FontFace
																	.font_size
																	.xx_inputlabel,
															fontFamily:
																'Inter-SemiBold',
															border: `solid 1px ${color.button.secondary}`,
															backgroundColor:
																color.background
																	.secondary,
															marginRight: '5px',
														}}
														className="bookmarkSaveButton"
														onClick={
															handleBookmarkSave
														}
													>
														{/* <span className="bookmarkSaveButtonText"> */}
										{/* Save */}
										{/* </span> */}
										{/* </Button>
												)}
												{isEditingBookmark && (
													<Button
														style={{
															textTransform:
																'none',
															letterSpacing:
																'normal',
															color: color.button
																.secondary_text,
															fontSize:
																FontFace
																	.font_size
																	.xx_inputlabel,
															fontFamily:
																'Inter-Regular',
															backgroundColor:
																'transparent',
															'&:hover': {
																backgroundColor:
																	'transparent',
															},
														}}
														className="clearAllButton"
														onClick={handleClearAll}
													>
														Clear All
													</Button>
												)}
											</Grid> */}
										{/* </Grid> */}
										{/* <Stack
											style={{
												display: 'flex',
												flexWrap: 'wrap',
												// margin: '8px',
											}}
											className="bookmarkChipSet"
											direction={'row'}
											// spacing={1}
										> */}
										{/* {!bookmarkList.length ? (
												<Typography
													style={{
														textAlign: 'center',
														color: color.text
															.secondary,
														fontSize:
															FontFace.font_size
																.x_small,
														fontFamily:
															'Inter-Regular',
														width: '396px',
														height: '16px',
													}}
												>
													Add your favourite bookmark
													list
												</Typography>
											) : isEditingBookmark ? (
												bookmarkList.map(
													(item, index) => (
														<Chip
															deleteIcon={
																<Close
																	width={
																		'14px'
																	}
																	height={
																		'14px'
																	}
																/>
															}
															key={index}
															label={item}
															// onDelete={() => {
															// 	handleDeleteBookmarkList(item)}}
															onDelete={()=>{}}
															sx={{
																'&.bookmarkChip':
																	{
																		'&:hover':
																			{
																				backgroundColor:
																					color
																						.button
																						.primary_outline_pressed,
																				color: color
																					.text
																					.hyperlink,
																			},
																	},
																display: 'flex',
																alignItems:
																	'center',
																justifyContent:
																	'center',
															}}
															className="bookmarkChip"
														/>
													)
												)
											) : (
												bookmarkList.map(
													(item, index) => (
														<Chip
															key={index}
															label={item}
															sx={{
																'&.bookmarkChip':
																	{
																		'&:hover':
																			{
																				backgroundColor:
																					color
																						.button
																						.primary_outline_pressed,
																				color: color
																					.text
																					.hyperlink,
																			},
																	},
																display: 'flex',
																alignItems:
																	'center',
																justifyContent:
																	'center',
															}}
															className="bookmarkChip"
														/>
													)
												)
											)}
										</Stack> */}
										{/* </Grid> */}

										{/* <Divider
										flexItem
										style={{
											width: '100%',
											marginTop: '10px',
											backgroundColor: '#dedede',
											height: '1px',
										}}
									/> */}
										<Grid
											item
											xs={12}
											style={{
												width: '437px',
											}}
										>
											{/* <Typography
											style={{
												color: color.text.primary,
												fontSize:
													FontFace.font_size
														.input_text,
												fontFamily: 'Inter-SemiBold',
											}}
										>
											&nbsp;
										</Typography> */}
											{/* {!recentSearches.length ? (
											<Grid sx={{ marginBottom: '20px' }}>
												<Typography
													style={{
														textAlign: 'center',
														color: color.text
															.secondary,
														fontSize:
															FontFace.font_size
																.x_small,
														fontFamily:
															'Inter-Bold',
														width: '425px',
														height: '16px',
													}}
												>
													No result found for your
													search.
												</Typography>
												<Typography
													style={{
														textAlign: 'center',
														color: color.text
															.secondary,
														fontSize:
															FontFace.font_size
																.x_small,
														fontFamily:
															'Inter-Regular',
														width: '425px',
														height: '16px',
													}}
												>
													Try with a different keyword
												</Typography>
											</Grid>
										) : (
											recentSearches.map(
												(item, index) => (
													<RecentSearchRow
														type="search"
														key={index}
														index={index}
														item={item}
														handleBookmark={
															handleBookmark
														}
														color={color}
														FontFace={FontFace}
														onClick={(item) => {
															if (
																item ===
																'Add  Site'
															) {
																handleGroupClick();
															} else if (
																item ===
																'Add  SSID'
															) {
																handleSSIDClick();
															} else if (
																item ===
																'Add  Switch'
															) {
																handleSwitchClick();
															} else if (
																item ===
																'Add  Access Point'
															) {
																handleApClick();
															}
														}}
													/>
												)
											)
										)} */}
											{/* {recentSearches.map(
												(item, index) => (
													<RecentSearchRow
														type="search"
														key={index}
														index={index}
														item={item}
														handleBookmark={
															handleBookmark
														}
														color={color}
														FontFace={FontFace}
														onClick={(item) => {
															if (
																item ===
																'Add / Site'
															) {
																handleGroupClick();
															} else if (
																item ===
																'Add / SSID'
															) {
																handleSSIDClick();
															} else if (
																item ===
																'Add / Switch'
															) {
																handleSwitchClick();
															} else if (
																item ===
																'Add / Access Point'
															) {
																handleApClick();
															}
														}}
													/>
												)
											)} */}
										</Grid>
										<Divider
											flexItem
											style={{
												width: '100%',
												marginTop: '10px',
												backgroundColor: '#dedede',
												height: '1px',
											}}
										/>

										<Grid item xs={12}>
											<Grid
												style={{
													padding: '12px',
													display: 'flex',
													flexDirection: 'row',
													justifyContent:
														'space-between',
													alignItems: 'center',
												}}
											>
												<Typography
													variant="h6"
													style={{
														color: color.text
															.primary,
														fontSize:
															FontFace.font_size
																.xx_inputlabel,
														fontFamily:
															'Inter-Bold',
													}}
												>
													Recently Searched
												</Typography>
												<Button
													style={{
														textTransform: 'none',
														letterSpacing: 'normal',
														color: color.button
															.secondary_text,
														fontSize:
															FontFace.font_size
																.xx_inputlabel,
														fontFamily:
															'Inter-Regular',
														backgroundColor:
															'transparent',
														'&:hover': {
															backgroundColor:
																'transparent',
														},
													}}
													className="clearAllButton"
													onClick={handleClearAll}
												>
													Clear All
												</Button>
											</Grid>
											{!recentSearches.length ? (
												<Grid
													sx={{
														marginBottom: '10px',
													}}
												>
													<Typography
														style={{
															textAlign: 'center',
															color: color.text
																.secondary,
															fontSize:
																FontFace
																	.font_size
																	.x_small,
															fontFamily:
																'Inter-Bold',
															width: '100%',
														}}
													>
														No recent search
													</Typography>
													{/* <Typography
													style={{
														textAlign: 'center',
														color: color.text
															.secondary,
														fontSize:
															FontFace.font_size
																.x_small,
														fontFamily:
															'Inter-Regular',
														width: '425px',
														height: '16px',
													}}
												>
													Try with a different keyword
												</Typography> */}
												</Grid>
											) : (
												recentSearches.map(
													(item, index) => (
														<RecentSearchRow
															type="recentsearch"
															key={index}
															index={index}
															item={item}
															handleBookmark={
																handleBookmark
															}
															color={color}
															FontFace={FontFace}
															onClick={
																handleRecentSearchClick
															}
															// 	if (
															// 		item ===
															// 		'Add Site'
															// 	) {
															// 		handleGroupClick();
															// 	} else if (
															// 		item ===
															// 		'Add SSID'
															// 	) {
															// 		handleSSIDClick();
															// 	} else if (
															// 		item ===
															// 		'Add Switch'
															// 	) {
															// 		handleSwitchClick();
															// 	} else if (
															// 		item ===
															// 		'Add Access Point'
															// 	) {
															// 		handleApClick();
															// 	}
															// }}
														/>
														// <div key={index} className="recentSearchRow">
														// 	<RecentIcon className="recentIcon" />
														// 	<Typography
														// 		style = {{
														// 			color: color.text.primary,
														// 			fontSize : FontFace.font_size.x_small,
														// 			fontFamily: 'Inter-Regular',
														// 	}}>{item}</Typography>
														// 	<IconButton
														// 		onClick={() => handleBookmark(item)}
														// 		// className={'testPinIcon'}
														// 		style={{ marginLeft: 'auto' }}
														// 	>
														// 		<SearchPinIcon />
														// 	</IconButton>
														// </div>
													),
												)
											)}
											{/* {recentSearches.map(
												(item, index) => (
													<RecentSearchRow
														type="recentsearch"
														key={index}
														index={index}
														item={item}
														handleBookmark={
															handleBookmark
														}
														color={color}
														FontFace={FontFace}
														onClick={(item) => {
															if (
																item ===
																'Add / Site'
															) {
																handleGroupClick();
															} else if (
																item ===
																'Add / SSID'
															) {
																handleSSIDClick();
															} else if (
																item ===
																'Add / Switch'
															) {
																handleSwitchClick();
															} else if (
																item ===
																'Add / Access Point'
															) {
																handleApClick();
															}
														}}
													/>
													// <div key={index} className="recentSearchRow">
													// 	<RecentIcon className="recentIcon" />
													// 	<Typography
													// 		style = {{
													// 			color: color.text.primary,
													// 			fontSize : FontFace.font_size.x_small,
													// 			fontFamily: 'Inter-Regular',
													// 	}}>{item}</Typography>
													// 	<IconButton
													// 		onClick={() => handleBookmark(item)}
													// 		// className={'testPinIcon'}
													// 		style={{ marginLeft: 'auto' }}
													// 	>
													// 		<SearchPinIcon />
													// 	</IconButton>
													// </div>
												)
											)} */}
										</Grid>
									</div>
								)}
								<>
									<Divider
										flexItem
										style={{
											width: '100%',
											marginTop: '10px',
											backgroundColor: '#dedede',
											height: '1px',
										}}
									/>
									<Grid item xs={12} style={{ padding: '12px' }}>
									<Typography
										variant="h6"
										style={{
											color: color.text.primary,
											fontSize:
												FontFace.font_size
													.xx_inputlabel,
											fontFamily: 'Inter-Bold',
										}}
									>
										Quick Access
									</Typography>
									<div className={'quickaccess-row'}>
										{filteredQuickSearch.length > 0 ? (
											filteredQuickSearch.map((object, index) => (
												<QuickSearch
													spacing={spacing}
													color={color}
													FontFace={FontFace}
													key={index}
													item={object}
													index={index}
													onClick={(item) => {
														if (item.icon === GroupsIcon) {
															handleGroupClick();
														} else if (item.icon === APIcon) {
															handleApClick();
														} else if (item.icon === SwitchIcon) {
															handleSwitchClick();
														} else if (item.icon === SsidAddIcon) {
															handleSSIDClick();
														} else if (item.icon === UserIcon) {
															handleUserClick();
														}
													}}
												/>
											))
										) : (
											<Typography
												style={{
													textAlign: 'center',
													color: color.text.secondary,
													fontSize: FontFace.font_size.x_small,
													fontFamily: 'Inter-Bold',
													width: '100%',
													padding: '8px 0',
												}}
											>
												No quick access available
											</Typography>
										)}
									</div>
									{/* Add icons for quick access menu */}
									</Grid>
									<Divider
										flexItem
										style={{
											width: '100%',
											backgroundColor: '#dedede',
											height: '1px',
										}}
									/>
								</>
							</Grid>
						</Paper>
					)}
				</Search>
			</div>
			{/* </Tooltip> */}
		</>
	);
};

export default AdvanceSearchBox;

const StyledDiv = styled('div')(({ color }) => ({
	color: color.text.primary,
	'&:hover': {
		backgroundColor: color.button.primary_outline_pressed,
	},
}));

const QuickSearch = ({ color, FontFace, item, index, spacing, onClick }) => (
	<div
		style={{
			display: 'flex',
			justifyContent: 'center',
			flexDirection: 'column',
			justifyItems: 'center',
			width: '70px',
			alignItems: 'center',
			cursor: 'pointer',
		}}
		onClick={() => onClick(item)}
	>
		<StyledDiv
			key={index}
			color={color}
			style={{ borderRadius: spacing.base_unit_2 }}
		>
			<item.icon width={'40px'} height={'40px'} />
		</StyledDiv>
		<Typography
			style={{
				color: color.text.primary,
				fontSize: FontFace.font_size.xx_small,
				fontFamily: 'Inter-Medium',
			}}
		>
			{item.text}
		</Typography>
	</div>
);

QuickSearch.propTypes = {
	item: PropTypes.string.isRequired,
	index: PropTypes.string.isRequired,
	color: PropTypes.object.isRequired,
	FontFace: PropTypes.object.isRequired,
	spacing: PropTypes.object.isRequired,
	onClick: PropTypes.func.isRequired,
};

const Search = styled('div')(({ theme, fontStyle, focused, tourStep }) => ({
	position: 'relative',
	borderRadius: theme.shape.borderRadius,
	backgroundColor: alpha(fontStyle.color.background.primary, 0.15),
	'&:hover': {
		backgroundColor: alpha(fontStyle.color.background.primary, 0.25),
	},
	border: (focused)
		? `2px solid ${fontStyle.color.input.line_active}`
		: `2px solid ${fontStyle.color.input.line}`,
	// height : "32px",
	marginLeft: 0,
	width: '100%',
	[theme.breakpoints.up('sm')]: {
		marginLeft: theme.spacing(1),
		width: 'auto', // Let the input control its width
	},
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
	padding: theme.spacing(0, 1),
	height: '100%',
	position: 'absolute',
	pointerEvents: 'none',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	// height : "32px",
}));

const StyledInputBase = styled(InputBase)(({ theme, fontStyle, focused, tourStep }) => {
	const inputBg = fontStyle.color.background.primary;

	return {
		justifyItems: 'center',
		justifyContent: 'center',
		width: '100%',
		backgroundColor: inputBg,
		'& .MuiInputBase-input': {
			padding: '8px 12px 8px 8px',
			color: fontStyle.color.text.primary,
			fontSize: fontStyle.FontFace.font_size.x_small,
			fontFamily: 'Inter-Regular',
			letterSpacing: 'normal',
			backgroundColor: inputBg,
			WebkitTapHighlightColor: 'transparent',
			paddingLeft: `calc(1em + ${theme.spacing(2)})`,
			transition: theme.transitions.create('width'),
			[theme.breakpoints.up('sm')]: {
				width: focused || tourStep === 3 ? '396px' : '224px',
				'&:focus': {
					width: focused || tourStep === 3 ? '396px' : '224px',
					backgroundColor: inputBg,
				},
			},
		},
		'& .MuiInputBase-input::selection': {
			backgroundColor: inputBg,
			color: fontStyle.color.text.primary,
		},
		'& .MuiInputBase-input::-moz-selection': {
			backgroundColor: inputBg,
			color: fontStyle.color.text.primary,
		},
		'& .MuiInputBase-input:-webkit-autofill': {
			WebkitBoxShadow: `0 0 0 1000px ${inputBg} inset`,
			WebkitTextFillColor: fontStyle.color.text.primary,
			caretColor: fontStyle.color.text.primary,
		},
		'& .MuiInputBase-input:-webkit-autofill:focus': {
			WebkitBoxShadow: `0 0 0 1000px ${inputBg} inset`,
			WebkitTextFillColor: fontStyle.color.text.primary,
		},
		'& .MuiInputBase-input::placeholder': {
			color: '#121212',
			opacity: 1,
		},
	};
});
